// import React, { useState } from 'react'
import moment from 'moment'
import { getDateRemainFromNow } from '_utils/function'
// import { FaShareSquare } from 'react-icons/fa'
// import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
// import { useToasts } from 'react-toast-notifications'
// import eventApi from '_api/event'
// import { useModal } from '_hooks/useModal'

export default function HeaderEventInfo({
  createdUserPhotoUrl,
  createdUserName,
  eClosingTime,
  eTotalOrderCount,
  groupName,
  collectionTimeStart = null,
  collectionTimeEnd = null,
  ePickupTime = null,
  isDisable,
  // isSharing = false,
  // eventId = null,
}) {
  // const { isOpen, openModal, closeModal } = useModal()
  // const [shareLink, setShareLink] = useState('')
  // const [textBtn, setTextBtn] = useState('COPY')
  // const [isLoading, setIsLoading] = useState(false)
  // const { addToast } = useToasts()

  // const handleShare = async () => {
  //   if (!eventId) {
  //     addToast('Event information is missing', { appearance: 'error', autoDismiss: true })
  //     return
  //   }

  //   setIsLoading(true)
  //   try {
  //     const response = await eventApi.createSharedEvent({ eid: eventId })
  //     const sharedId = response?.msgCode === 75000 ? response?.msgResp : null

  //     if (sharedId) {
  //       const url =
  // `${process.env.REACT_APP_APP_URL}/event/detail-shared?eid=${eventId}&sharedId=${sharedId}`
  //       setShareLink(url)
  //       setTextBtn('COPY')
  //       openModal()
  //     } else {
  //       addToast('Failed to create share link', { appearance: 'error', autoDismiss: true })
  //     }
  //   } catch (error) {
  //     addToast(error?.msgResp || 'Failed to create share link', {
  //       appearance: 'error',
  //       autoDismiss: true,
  //     })
  //   } finally {
  //     setIsLoading(false)
  //   }
  // }

  // const handleOnCopy = () => {
  //   navigator.clipboard.writeText(shareLink)
  //   setTextBtn('COPIED')
  // }

  return (
    <>
      <div className='group-list__img'>
        <div className='c-image'>
          <a href='' onClick={(e) => e.preventDefault()}>
            {' '}
            <img
              src={createdUserPhotoUrl || process.env.REACT_APP_AVATAR_URL + createdUserName}
              style={isDisable ? { filter: 'grayscale(100%)' } : {}}
              alt=''
            />
          </a>
        </div>
      </div>
      <div className='group-list__info'>
        <h3>
          <a href='' onClick={(e) => e.preventDefault()}>
            {createdUserName}
          </a>
        </h3>
        <p>{groupName}</p>
        <p>
          <a href='#'></a>
        </p>
      </div>
      <div>
        <div className='group-list__btn text-right'>
          <span className='txt-date mb-2' style={{ lineHeight: '1.3' }}>
            {ePickupTime && collectionTimeStart && collectionTimeEnd ? (
              <div>
                <span>{moment(ePickupTime, 'DD-MM-YYYY').format('DD-MM-YYYY')}</span>
                <span
                  style={{ display: 'block' }}
                >{`${collectionTimeStart} - ${collectionTimeEnd}`}</span>
              </div>
            ) : (
              <span>{`closing in ${getDateRemainFromNow(eClosingTime)}`}</span>
            )}
          </span>
          <span
            className='txt-number'
            style={isDisable ? { backgroundColor: 'gray' } : {}}
          >{`${eTotalOrderCount} BUY`}</span>
        </div>
        {/* {isSharing && (
          <div
            className='text-right cursor-pointer'
            style={{ fontSize: '1.1rem' }}
            onClick={handleShare}
          >
            {isLoading ? (
              <span style={{ fontSize: '0.8rem' }}>Loading...</span>
            ) : (
              <FaShareSquare />
            )}
          </div>
        )} */}
      </div>

      {/* <Modal isOpen={isOpen} toggle={closeModal} centered>
        <ModalHeader className='modal-header-created'>
          <span className='c-txt-gray'>Share Link</span>
        </ModalHeader>
        <ModalBody>
          <div className='c-form'>
            <div className='form-group'>
              <input
                type='text'
                className='form-control form-control--radius shareLink'
                value={shareLink}
                readOnly
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter className='modal-footer-created'>
          <div className='col-12'>
            <button className='btn btn--org btn--org02' onClick={handleOnCopy}>
              {textBtn}
            </button>
          </div>
          <div className='col-12 mt-2'>
            <button className='btn btn--solid btn--solid04' onClick={closeModal}>
              CLOSE
            </button>
          </div>
        </ModalFooter>
      </Modal> */}
    </>
  )
}
